/**Dependencies */
import React, { useState } from 'react'

/**Components */
import { PrincipalBanner } from '../components/PrincipalBanner';
import bannerIntermedio from "../images/banners/banner-intermedio-circuitos.jpg";
import { InformationSection } from '../components/InformationSection';
import { infoSpecialCircuits } from '../helpers';

export const Circuitos = () => {
  const [source, setSource] = useState("https://www.megatravel.com.mx/tools/ofertas-viaje.php? Dest=&txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1");
  const [title, setTitle] = useState("Promociones de temporada");
  // const handleShowModal = (sourceIn, titleIn) => {
  //   setSource(sourceIn); // Guarda el ID de la habitación activa
  //   setTitle(titleIn); // Muestra el modal
  // };
  const iframes = [
    { title: "Promociones de temporada", url: "https://www.megatravel.com.mx/tools/vi.php", inName: "Promociones"},
    { title: "Viajes a Europa", url: "https://www.megatravel.com.mx/tools/vi.php?Dest=1", inName: "Europa"},
    { title: "Viajes a Estados Unidos", url: "https://www.megatravel.com.mx/tools/vi.php?Dest=8", inName: "Estados Unidos"},
    { title: "Viajes al Medio Oriente", url: "https://www.megatravel.com.mx/tools/vi.php?Dest=2", inName: "Medio Oriente"},
    { title: "Viajes a Canada", url: "https://www.megatravel.com.mx/tools/vi.php?Dest=3", inName: "Canada"},
    { title: "Viajes a Sudamerica", url: "https://www.megatravel.com.mx/tools/vi.php?Dest=7", inName: "Sudamerica"},
    { title: "Viajes a Centroamerica", url: "https://www.megatravel.com.mx/tools/vi.php?Dest=9", inName: "Centroamerica"},
    { title: "Viajes al Caribe", url: "https://www.megatravel.com.mx/tools/vi.php?Dest=10", inName: "Caribe"},
    { title: "Viajes a Nacionales", url: "https://www.megatravel.com.mx/tools/vi.php?Dest=11", inName: "Nacionales"},
    { title: "Viajes Asia", url: "https://www.megatravel.com.mx/tools/vi.php?Dest=4", inName: "Asia"},
    { title: "Viajes a Africa", url: "https://www.megatravel.com.mx/tools/vi.php?Dest=5", inName: "Africa"},
    { title: "Viajes Pacifico", url: "https://www.megatravel.com.mx/tools/vi.php?Dest=6", inName: "Pacifico"},
    { title: "Cruceros", url: "https://www.megatravel.com.mx/tools/vi.php?Dest=13", inName: "Cruceros"},
  ]
  return (
    <div className='circuitos'>
      <PrincipalBanner idElemento={3} showSearch={false} />

      <div className='container py-5'>
        <div className="text-center mb-5">
          <h1 className='section-title'>Lugares internacionales que puedes visitar</h1>
        </div>
        <div>
          {/* <div>
            <ul id="framemenu" className='row'>
              {iframes?.map((iframe) => (
                <li onClick={() =>
                  handleShowModal(iframe.url, iframe.title)
                }
                  className='iframes-megatravel-list-item col-2'>
                  <a rel={ iframe.url } title={ iframe.title }>{ iframe.inName }
                  </a>
                </li>
              ))}
            </ul>
          </div> */}
          <div className="carousel-container pb-5">
            {/* <h1 id="titulo">{ title }</h1> */}
            <iframe src={source} title='iframe-megatravel' border="0" align="center" allowtransparency="true" frameborder="0" style={{ width: '100%', height: '700px' }}></iframe>
            {/* <iframe title='frame-circuits' src="https://www.megatravel.com.mx/tools/ofertas-viaje.php?Dest=&txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1"
              border="0" align="center" allowtransparency="true" frameborder="0" style={{ width: '100%', height: '700px' }}> </iframe> */}
          </div>
        </div>
      </div>

      <div className="image-container mt-3 mb-5">
        <img
          src={bannerIntermedio}
          alt="Fondo"
        />
      </div>

      <div className='container py-5'>
        <div className="text-center mb-5">
          <h1 className='section-title'>Más destinos para viajar</h1>
        </div>
        <div>
          {/* <div>
            <ul id="framemenu" className='row'>
              {iframes?.map((iframe) => (
                <li onClick={() =>
                  handleShowModal(iframe.url, iframe.title)
                }
                  className='iframes-megatravel-list-item col-2'>
                  <a rel={ iframe.url } title={ iframe.title }>{ iframe.inName }
                  </a>
                </li>
              ))}
            </ul>
          </div> */}
          <div className="carousel-container pb-5">
            <h1 id="titulo">{ title }</h1>
            <iframe src="https://nefertaritravel.com.mx/sg/?iframe=yes%22" title='iframe-megatravel' border="0" align="center" allowtransparency="true" frameborder="0" style={{ width: '100%', height: '700px' }}></iframe>
            {/* <iframe title='frame-circuits' src="https://www.megatravel.com.mx/tools/ofertas-viaje.php?Dest=&txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1"
              border="0" align="center" allowtransparency="true" frameborder="0" style={{ width: '100%', height: '700px' }}> </iframe> */}
          </div>
        </div>
      </div>

      <div className='py-5'>
        <InformationSection arrInfo={infoSpecialCircuits} />
      </div>
    </div>
  )
}
